const userFriendlyEr = {
  recognize: function (e, endpoint = null) {
    console.warn('recognize Error', e)
    let errMsg = 'Неизвестная ошибка'
    if (e && e.data && e.data.status) {
      if (e.data.message) {
        errMsg = e.data.message
      } else {
        errMsg = 'Ошибка - ' + e.data.status
      }
    } else if (e && e.status) {
      if (e.data.errors) {
        let msg = ''
        for (let fieldName in e.data.errors) {
          msg += ' ' + e.data.errors[fieldName]
        }
        errMsg = msg
      } else if (e.data.message) {
        let msg = ''
        if (e.status) {
          msg = 'Ошибка: ' + (e.status || 101)
        }
        errMsg = `${msg} ${e.data.message}`
      } else {
        errMsg = 'Ошибка: ' + e.status
      }
    } else if (e && e.response && e.response.data && e.response.data.message) {
      errMsg = e.response.data.message
    } else if (e && e.message) {
      errMsg = e.message
      if (errMsg === 'Network Error') {
        errMsg = 'Отсутствует интернет либо сервер временно недоступен'
      }
    } else if (e) {
      errMsg = e.toString()
    }
    if (endpoint) {
      errMsg = `${errMsg} URL api вызвавший ошибку: ${endpoint}`
    }
    return errMsg
  },
  recognizeServerValidation: function (e) {
    let data = e.data || e.response || e
    let msg = ''
    if (data.errors) {
      for (let fieldName in data.errors) {
        msg += ' ' + data.errors[fieldName]
      }
    }
    return msg
  }
}

export default userFriendlyEr
